import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatToggle = createCustomElementWrapper('kat-toggle', 'KatToggle', {
    'textChecked': 'text-checked',
    'textUnchecked': 'text-unchecked',
    'uniqueId': 'unique-id',
}, {
    'onChange': 'change',
}, [
    'unchecked',
]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/toggle.js
// module id = 1319
// module chunks = 0